import type { GroupPrivate } from '@repo/types/groups';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GroupService, type GroupCreateData } from './groupService';
import { GroupKey } from './keys';

export function usePostGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: GroupCreateData) => GroupService.addGroup(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.setQueryData([GroupKey.GROUPS], (curr?: GroupPrivate[]) => {
        if (!curr) {
          return;
        }
        return [...curr, data];
      });
      queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUPS],
      });
    },
  });
}
